import { mergeDeep } from '@/helpers/utils'
import { ISchema, PaywallComponentProps } from '../@types'

export default (schema: ISchema): ISchema =>
	mergeDeep(
		{ ...schema },
		{
			order: [
				'PaywallCountdownQuickAccess',
				'PaywallHead',
				'PaywallWeightPredict',
				[
					'PaywallTitle',
					({ ctx, $t }): PaywallComponentProps.Title => ({
						title: ctx.hasAiCoach
							? 'Grab your Personal Plan + <span class="text-success">AI Coach</span> before it’s gone!'
							: $t('pages.program.title_grab'),
					}),
				],
				'PaywallCountdown',
				'PaywallPlanPicker',
				'PaywallUserResearchBadge',
				[
					'PaywallButton',
					({ $t }): PaywallComponentProps.Button => ({
						text: $t('common.controls.get_my_plan'),
						type: 'GET_MY_PLAN_PLANPICKER',
						blockViewTitle: 'ONBOARDING_PAYWALL_PRODUCT_SELECTION_1_BLOCK',
						clickEvent: 'openBillingModal',
					}),
				],
				'PaywallPromocode',
				'PaywallAiCoachBanner',
				'PaywallPriceDisclaimer',
				'PaywallRatings',
				'PaywallDietsVsFasting',
				[
					'PaywallButton',
					({ $t, ctx }): PaywallComponentProps.Button => ({
						text: $t('pages.program.buttons.grab_my_plan_to_hit', {
							weight: ctx.localizedUserTargetWeight,
						}),
						type: 'GET_MY_PLAN_HIGHLIGHTS',
						clickEvent: 'openBillingModal',
					}),
				],
				'PaywallCustomerReviews',
				[
					'PaywallTitle',
					({ $t }): PaywallComponentProps.Title => ({
						title: $t('prepaywall.crm.visible_result.title'),
						customStyles: {
							marginLeft: '20px',
							marginRight: '20px',
						},
					}),
				],
				'PaywallCountdown',
				'PaywallPlanPicker',
				'PaywallUserResearchBadge',
				[
					'PaywallButton',
					({ $t }): PaywallComponentProps.Button => ({
						text: $t('common.controls.get_my_plan'),
						type: 'GET_MY_PLAN_PLANPICKER',
						blockViewTitle: 'ONBOARDING_PAYWALL_PRODUCT_SELECTION_2_BLOCK',
						clickEvent: 'openBillingModal',
					}),
				],
				'PaywallPromocode',
				'PaywallPriceDisclaimer',
				'PaywallFooterWithMoneyback',
				'PaywallBillingModal',
			],
		},
	)
